import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as _ from 'lodash';
import { map } from 'rxjs/operators';
import { of, Subject } from 'rxjs';
import { getCarPartsChildItems } from './mock-data/child-item';
import { EnvironmentService } from '../../service/service.module';

@Injectable({
  providedIn: 'root'
})
export class CarpartsService {

  environment = EnvironmentService.environment;

  // Subjects
  public childGridActionSubject: Subject<any> = new Subject();

  /* Set Subjects for HEADER COLUMN EDIT/REMOVE */
  setChildGridActionSubject = (value: any) => { this.childGridActionSubject.next(value); };

  // Observables
  getChildGridActionSubject = () => this.childGridActionSubject.asObservable();


  constructor(private http: HttpClient) {
  }

  GetItemsImportTemplate() {
    return this.http.get<any>(`${this.environment.AppCommonCode}/exportdemoitemstemplate`)
      .pipe(map((data: any) => {
        return data;
      }));
  }

  getCarPartsChildItems(filterBody: any) {
    let childItems: any = getCarPartsChildItems();
    if (!_.isEmpty(filterBody)) {
      childItems = childItems.filter((a: any) => {
        let isFiltered: boolean = true;
        if (filterBody.Title) {
          isFiltered = _.lowerCase(a.Title).includes(_.lowerCase(filterBody.Title));
        }
        if (filterBody.Makes) {
          isFiltered = isFiltered && filterBody.Makes.includes(a.Make);
        }
        if (filterBody.Models) {
          isFiltered = isFiltered && filterBody.Models.includes(a.Model);
        }
        if (filterBody.Years) {
          isFiltered = isFiltered && filterBody.Years.includes(a.Year);
        }
        if (filterBody.Brands) {
          isFiltered = isFiltered && filterBody.Brands.includes(a.Brand);
        }
        return isFiltered;
      });
    }

    return of(childItems);
  }

  GetItemMakeList() {
    const childItems = getCarPartsChildItems();
    const makeList = _.sortBy(_.uniq(_.map(childItems, a => a.Make)), a => a);
    return of(makeList);
  }

  GetItemModelList() {
    const childItems = getCarPartsChildItems();
    const modelList = _.sortBy(_.uniq(_.map(childItems, a => a.Model)), a => a);
    return of(modelList);
  }

  GetItemYearList() {
    const childItems = getCarPartsChildItems();
    const yearList = _.sortBy(_.uniq(_.map(childItems, a => a.Year)), a => a);
    return of(yearList);
  }

  GetItemBrandList() {
    const childItems = getCarPartsChildItems();
    const brandList = _.sortBy(_.uniq(_.map(childItems, a => a.Brand)), a => a);
    return of(brandList);
  }

  GetItemClassList() {
    const childItems = getCarPartsChildItems();
    const classList = _.sortBy(_.uniq(_.map(childItems, a => a.Class)), a => a);
    return of(classList);
  }

  GetPromoNameList() {
    const childItems = getCarPartsChildItems();
    const promoNameList = _.sortBy(_.uniq(_.map(childItems, a => a.Promo_Name)), a => a);
    return of(promoNameList);
  }

  GetItemSubClassList() {
    const childItems = getCarPartsChildItems();
    const subClassList = _.sortBy(_.uniq(_.map(childItems, a => a.SubClass)), a => a);
    return of(subClassList);
  }

  GetMonthList() {
    const childItems = getCarPartsChildItems();
    const monthList = _.sortBy(_.uniq(_.map(childItems, a => a.Month)), a => a);
    return of(monthList);
  }

  GetSubmittedByList() {
    const childItems = getCarPartsChildItems();
    const submittedByList = _.sortBy(_.uniq(_.map(childItems, a => a.Submitted_By)), a => a);
    return of(submittedByList);
  }

  GetFulfillmentTypeList() {
    const childItems = getCarPartsChildItems();
    const fulfillmentTypeList = _.sortBy(_.uniq(_.map(childItems, a => a.Fulfillment_Type)), a => a);
    return of(fulfillmentTypeList);
  }

  GetActionsList() {
    const actionList = [
      'Pitched',
      'Accepted',
      'Rejected',
      'Deleted',
      'Modified',
      'EOL'
    ];
    return of(actionList);
  }


  GetNewItemPromotionDetail(filterBody: any) {
    let childItems: any = getCarPartsChildItems();
    if (!_.isEmpty(filterBody)) {
      childItems = childItems.filter((a: any) => {
        let isFiltered: boolean = true;
        if (filterBody.Month) {
          isFiltered = isFiltered && filterBody.Month === a.Month;
        }
        if (filterBody.Actions) {
          isFiltered = isFiltered && filterBody.Actions.includes(a.Status);
        }
        if (filterBody.Makes) {
          isFiltered = isFiltered && filterBody.Makes.includes(a.Make);
        }
        if (filterBody.Models) {
          isFiltered = isFiltered && filterBody.Models.includes(a.Model);
        }
        if (filterBody.Years) {
          isFiltered = isFiltered && filterBody.Years.includes(a.Year);
        }
        if (filterBody.Brands) {
          isFiltered = isFiltered && filterBody.Brands.includes(a.Brand);
        }
        if (filterBody.PromoName) {
          isFiltered = isFiltered && filterBody.PromoName === a.Promo_Name;
        }
        if (filterBody.SubmittedBy) {
          isFiltered = isFiltered && filterBody.SubmittedBy === a.Submitted_By;
        }
        if (filterBody.FulfillmentType) {
          isFiltered = isFiltered && filterBody.FulfillmentType === a.Fulfillment_Type;
        }
        return isFiltered;
      });
    }
    return of(childItems);
  }

  GetNewItemPromotionForecast(filterBody: any) {
    let childItems: any = getCarPartsChildItems();
    if (!_.isEmpty(filterBody)) {
      childItems = childItems.filter((a: any) => {
        let isFiltered: boolean = true;
        if (filterBody.Month) {
          isFiltered = isFiltered && filterBody.Month === a.Month;
        }
        if (filterBody.Actions) {
          isFiltered = isFiltered && filterBody.Actions.includes(a.Status);
        }
        if (filterBody.Brands) {
          isFiltered = isFiltered && filterBody.Brands.includes(a.Brand);
        }
        return isFiltered;
      });
    }

    return of(childItems);
  }

}
